import * as tslib_1 from "tslib";
import { SvgView } from '@swim/ui';
import { PlotPointView } from './plot-point-view';
var PlotView = (function (_super) {
    tslib_1.__extends(PlotView, _super);
    function PlotView(plot) {
        var _this = _super.call(this, plot.node) || this;
        _this.plot = plot;
        _this._axisX = null;
        _this._axisY = null;
        _this.plot.addObserver(_this);
        return _this;
    }
    PlotView.prototype.getPoint = function (x) {
        return this.plot.getPoint(x);
    };
    PlotView.prototype.insertPoint = function (newPoint) {
        this.plot.insertPoint(newPoint);
    };
    PlotView.prototype.removePoint = function (x) {
        this.plot.removePoint(x);
    };
    PlotView.prototype.axisX = function (axisX) {
        if (axisX === undefined) {
            return this._axisX;
        }
        else {
            this._axisX = axisX;
            this.plot.axisX(axisX ? axisX.axis : null);
            return this;
        }
    };
    PlotView.prototype.scaleX = function (value, trans) {
        if (!this._axisX) {
            throw new Error();
        }
        if (value === undefined) {
            return this._axisX.scale();
        }
        else {
            this._axisX.scale(value, trans);
            return this;
        }
    };
    PlotView.prototype.domainX = function (x0, x1, trans) {
        if (!this._axisX) {
            throw new Error();
        }
        if (x0 === undefined) {
            return this._axisX.domain();
        }
        else {
            this._axisX.domain(x0, x1, trans);
            return this;
        }
    };
    PlotView.prototype.rangeX = function (r0, r1, trans) {
        if (!this._axisX) {
            throw new Error();
        }
        if (r0 === undefined) {
            return this._axisX.range();
        }
        else {
            this._axisX.range(r0, r1, trans);
            return this;
        }
    };
    PlotView.prototype.axisY = function (axisY) {
        if (axisY === undefined) {
            return this._axisY;
        }
        else {
            this._axisY = axisY;
            this.plot.axisY(axisY ? axisY.axis : null);
            return this;
        }
    };
    PlotView.prototype.scaleY = function (value, trans) {
        if (!this._axisY) {
            throw new Error();
        }
        if (value === undefined) {
            return this._axisY.scale();
        }
        else {
            this._axisY.scale(value, trans);
            return this;
        }
    };
    PlotView.prototype.domainY = function (y0, y1, trans) {
        if (!this._axisY) {
            throw new Error();
        }
        if (y0 === undefined) {
            return this._axisY.domain();
        }
        else {
            this._axisY.domain(y0, y1, trans);
            return this;
        }
    };
    PlotView.prototype.rangeY = function (r0, r1, trans) {
        if (!this._axisY) {
            throw new Error();
        }
        if (r0 === undefined) {
            return this._axisY.range();
        }
        else {
            this._axisY.range(r0, r1, trans);
            return this;
        }
    };
    PlotView.prototype.transformX = function (transformX) {
        if (transformX === undefined) {
            return this.plot.transformX();
        }
        else {
            this.plot.transformX(transformX);
            return this;
        }
    };
    PlotView.prototype.transformY = function (transformY) {
        if (transformY === undefined) {
            return this.plot.transformY();
        }
        else {
            this.plot.transformY(transformY);
            return this;
        }
    };
    PlotView.prototype.plotDidScaleX = function (scale, axis, plot) {
    };
    PlotView.prototype.plotDidScaleY = function (scale, axis, plot) {
    };
    PlotView.prototype.plotDidInsertPoint = function (point, plot) {
    };
    PlotView.prototype.plotDidRemovePoint = function (point, plot) {
    };
    PlotView.prototype.insertPlotPointViews = function () {
        for (var i = 0; i < this._childViews.length; i += 1) {
            var point = this._childViews[i];
            if (point instanceof PlotPointView && point.x !== undefined) {
                this.insertPoint(point);
            }
        }
    };
    PlotView.prototype.render = function () {
    };
    PlotView.prototype.addObserver = function (observer) {
        this.plot.addObserver(observer);
    };
    PlotView.prototype.removeObserver = function (observer) {
        this.plot.removeObserver(observer);
    };
    return PlotView;
}(SvgView));
export { PlotView };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxvdC12aWV3LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicGxvdC12aWV3LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQXFDLE9BQU8sRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUd0RSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFHbEQ7SUFBNkMsb0NBQU87SUFPbEQsa0JBQVksSUFBZ0I7UUFBNUIsWUFDRSxrQkFBTSxJQUFJLENBQUMsSUFBSSxDQUFDLFNBS2pCO1FBSkMsS0FBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7UUFDakIsS0FBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUM7UUFDbkIsS0FBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUM7UUFDbkIsS0FBSSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsS0FBSSxDQUFDLENBQUM7O0lBQzlCLENBQUM7SUFFRCwyQkFBUSxHQUFSLFVBQVMsQ0FBSTtRQUNYLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUMvQixDQUFDO0lBRUQsOEJBQVcsR0FBWCxVQUFZLFFBQXlCO1FBQ25DLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ2xDLENBQUM7SUFFRCw4QkFBVyxHQUFYLFVBQVksQ0FBSTtRQUNkLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQzNCLENBQUM7SUFJRCx3QkFBSyxHQUFMLFVBQU0sS0FBMEI7UUFDOUIsRUFBRSxDQUFDLENBQUMsS0FBSyxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUM7WUFDeEIsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7UUFDckIsQ0FBQztRQUFDLElBQUksQ0FBQyxDQUFDO1lBQ04sSUFBSSxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUM7WUFDcEIsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUMzQyxNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ2QsQ0FBQztJQUNILENBQUM7SUFJRCx5QkFBTSxHQUFOLFVBQU8sS0FBMkMsRUFBRSxLQUF5QztRQUMzRixFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO1lBQ2pCLE1BQU0sSUFBSSxLQUFLLEVBQUUsQ0FBQztRQUNwQixDQUFDO1FBQ0QsRUFBRSxDQUFDLENBQUMsS0FBSyxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUM7WUFDeEIsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxFQUFFLENBQUM7UUFDN0IsQ0FBQztRQUFDLElBQUksQ0FBQyxDQUFDO1lBQ04sSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDO1lBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUM7UUFDZCxDQUFDO0lBQ0gsQ0FBQztJQUlELDBCQUFPLEdBQVAsVUFBUSxFQUFxQixFQUFFLEVBQU0sRUFBRSxLQUF5QztRQUM5RSxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO1lBQ2pCLE1BQU0sSUFBSSxLQUFLLEVBQUUsQ0FBQztRQUNwQixDQUFDO1FBQ0QsRUFBRSxDQUFDLENBQUMsRUFBRSxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUM7WUFDckIsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxFQUFFLENBQUM7UUFDOUIsQ0FBQztRQUFDLElBQUksQ0FBQyxDQUFDO1lBQ04sSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLEVBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQztZQUNsQyxNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ2QsQ0FBQztJQUNILENBQUM7SUFJRCx5QkFBTSxHQUFOLFVBQU8sRUFBc0IsRUFBRSxFQUFXLEVBQUUsS0FBeUM7UUFDbkYsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztZQUNqQixNQUFNLElBQUksS0FBSyxFQUFFLENBQUM7UUFDcEIsQ0FBQztRQUNELEVBQUUsQ0FBQyxDQUFDLEVBQUUsS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDO1lBQ3JCLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssRUFBRSxDQUFDO1FBQzdCLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEVBQUUsRUFBRSxFQUFFLEVBQUUsS0FBSyxDQUFDLENBQUM7WUFDakMsTUFBTSxDQUFDLElBQUksQ0FBQztRQUNkLENBQUM7SUFDSCxDQUFDO0lBSUQsd0JBQUssR0FBTCxVQUFNLEtBQTBCO1FBQzlCLEVBQUUsQ0FBQyxDQUFDLEtBQUssS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDO1lBQ3hCLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQ3JCLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLElBQUksQ0FBQyxNQUFNLEdBQUcsS0FBSyxDQUFDO1lBQ3BCLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDM0MsTUFBTSxDQUFDLElBQUksQ0FBQztRQUNkLENBQUM7SUFDSCxDQUFDO0lBSUQseUJBQU0sR0FBTixVQUFPLEtBQTJDLEVBQUUsS0FBeUM7UUFDM0YsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztZQUNqQixNQUFNLElBQUksS0FBSyxFQUFFLENBQUM7UUFDcEIsQ0FBQztRQUNELEVBQUUsQ0FBQyxDQUFDLEtBQUssS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDO1lBQ3hCLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssRUFBRSxDQUFDO1FBQzdCLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUMsQ0FBQztZQUNoQyxNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ2QsQ0FBQztJQUNILENBQUM7SUFJRCwwQkFBTyxHQUFQLFVBQVEsRUFBcUIsRUFBRSxFQUFNLEVBQUUsS0FBeUM7UUFDOUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztZQUNqQixNQUFNLElBQUksS0FBSyxFQUFFLENBQUM7UUFDcEIsQ0FBQztRQUNELEVBQUUsQ0FBQyxDQUFDLEVBQUUsS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDO1lBQ3JCLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLE1BQU0sRUFBRSxDQUFDO1FBQzlCLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEVBQUUsRUFBRSxFQUFFLEVBQUUsS0FBSyxDQUFDLENBQUM7WUFDbEMsTUFBTSxDQUFDLElBQUksQ0FBQztRQUNkLENBQUM7SUFDSCxDQUFDO0lBSUQseUJBQU0sR0FBTixVQUFPLEVBQXNCLEVBQUUsRUFBVyxFQUFFLEtBQXlDO1FBQ25GLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUM7WUFDakIsTUFBTSxJQUFJLEtBQUssRUFBRSxDQUFDO1FBQ3BCLENBQUM7UUFDRCxFQUFFLENBQUMsQ0FBQyxFQUFFLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQztZQUNyQixNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUM3QixDQUFDO1FBQUMsSUFBSSxDQUFDLENBQUM7WUFDTixJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxFQUFFLEVBQUUsRUFBRSxFQUFFLEtBQUssQ0FBQyxDQUFDO1lBQ2pDLE1BQU0sQ0FBQyxJQUFJLENBQUM7UUFDZCxDQUFDO0lBQ0gsQ0FBQztJQUlELDZCQUFVLEdBQVYsVUFBVyxVQUE2QjtRQUN0QyxFQUFFLENBQUMsQ0FBQyxVQUFVLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQztZQUM3QixNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQztRQUNoQyxDQUFDO1FBQUMsSUFBSSxDQUFDLENBQUM7WUFDTixJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxVQUFVLENBQUMsQ0FBQztZQUNqQyxNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ2QsQ0FBQztJQUNILENBQUM7SUFJRCw2QkFBVSxHQUFWLFVBQVcsVUFBNkI7UUFDdEMsRUFBRSxDQUFDLENBQUMsVUFBVSxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUM7WUFDN0IsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVSxFQUFFLENBQUM7UUFDaEMsQ0FBQztRQUFDLElBQUksQ0FBQyxDQUFDO1lBQ04sSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsVUFBVSxDQUFDLENBQUM7WUFDakMsTUFBTSxDQUFDLElBQUksQ0FBQztRQUNkLENBQUM7SUFDSCxDQUFDO0lBRUQsZ0NBQWEsR0FBYixVQUFjLEtBQWlDLEVBQUUsSUFBYSxFQUFFLElBQWdCO0lBRWhGLENBQUM7SUFFRCxnQ0FBYSxHQUFiLFVBQWMsS0FBaUMsRUFBRSxJQUFhLEVBQUUsSUFBZ0I7SUFFaEYsQ0FBQztJQUVELHFDQUFrQixHQUFsQixVQUFtQixLQUFzQixFQUFFLElBQWdCO0lBRTNELENBQUM7SUFFRCxxQ0FBa0IsR0FBbEIsVUFBbUIsS0FBc0IsRUFBRSxJQUFnQjtJQUUzRCxDQUFDO0lBR0QsdUNBQW9CLEdBQXBCO1FBQ0UsR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUM7WUFDcEQsSUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUNsQyxFQUFFLENBQUMsQ0FBQyxLQUFLLFlBQVksYUFBYSxJQUFJLEtBQUssQ0FBQyxDQUFDLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQztnQkFDNUQsSUFBSSxDQUFDLFdBQVcsQ0FBQyxLQUFLLENBQUMsQ0FBQztZQUMxQixDQUFDO1FBQ0gsQ0FBQztJQUNILENBQUM7SUFFRCx5QkFBTSxHQUFOO0lBRUEsQ0FBQztJQUVELDhCQUFXLEdBQVgsVUFBWSxRQUE0QjtRQUN0QyxJQUFJLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUNsQyxDQUFDO0lBRUQsaUNBQWMsR0FBZCxVQUFlLFFBQTRCO1FBQ3pDLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ3JDLENBQUM7SUFDSCxlQUFDO0FBQUQsQ0FBQyxBQWxNRCxDQUE2QyxPQUFPLEdBa01uRCJ9